import { LitElement, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { TW } from '../../shared'

const TwLitElement = TW(LitElement)

/**
 * Simple Breakpoint Indicator
 * 
 * @author jjarolim
 */
@customElement('breakpoint-indicator')
export class BreakpointIndicator extends TwLitElement {

    render() 
    {
        return html`
            <div class="p-3 bg-yellow-400/80 rounded-md text-md font-bold leading-none">
                <div class="sm:hidden">XS</div>
                <div class="hidden sm:block md:hidden">SM</div>
                <div class="hidden md:block lg:hidden">MD</div>
                <div class="hidden lg:block xl:hidden">LG</div>
                <div class="hidden xl:block 2xl:hidden">XL</div>
                <div class="hidden 2xl:block 3xl:hidden">2XL</div>
                <div class="hidden 3xl:block">3XL</div>
            <div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'breakpoint-indicator': BreakpointIndicator
    }
}
